import React, { useState } from 'react';
import './ViewDetails.scss';
import { FiSearch, FiCalendar, FiFilter, FiDownload } from 'react-icons/fi';
import { FiCopy } from 'react-icons/fi';
import { FaArrowUp } from "react-icons/fa";

const ViewDetails = () => {
  const [selectedTimeframe, setSelectedTimeframe] = useState('All times');
  const [activeRow, setActiveRow] = useState(null);
  const [open, setOpen] = useState(null);


  const toggleDetails = (index) => {
    setActiveRow(activeRow === index ? null : index);
  };
  const timeframes = [
    { id: 'all', label: 'All times' },
    { id: '24h', label: '24 Hour' },
    { id: '7d', label: '7 Days' },
    { id: '30d', label: '30 Days' },
    { id: '12m', label: '12 Months' },
  ];
  const orders = [
    {
      clientName: 'Name here',
      orderDate: '12 Aug 2022',
      time: '12:55 am',
      orderID: '#93481073',
      results: '+1 Point',
      status: 'New'
    },
    {
      clientName: 'Name here',
      orderDate: '12 Aug 2022',
      time: '00:00 am',
      orderID: '#93481073',
      results: '0 Point',
      status: 'New'
    },
    {
      clientName: 'Name here',
      orderDate: '12 Aug 2022',
      time: '00:00 am',
      orderID: '#93481073',
      results: '0 Point',
      status: 'On Process'
    },
    {
      clientName: 'Name here',
      orderDate: '12 Aug 2022',
      time: '12:40 am',
      orderID: '#93481073',
      results: '+1 Point',
      status: 'complete'
    },
    {
      clientName: 'Name here',
      orderDate: '12 Aug 2022',
      time: 'Times Up',
      orderID: '#93481073',
      results: '-1 Point',
      status: 'complete'
    },
    {
      clientName: 'Name here',
      orderDate: '12 Aug 2022',
      time: '12:30 am',
      orderID: '#93486P73',
      results: '+1 Point',
      status: 'complete'
    },
    {
      clientName: 'Name here',
      orderDate: '12 Aug 2022',
      time: '00:00 am',
      orderID: '#93486P73',
      results: '0 Point',
      status: 'New'
    },
    {
      clientName: 'Name here',
      orderDate: '12 Aug 2022',
      time: '00:00 am',
      orderID: '#93481073',
      results: '0 Point',
      status: 'New'
    },
    {
      clientName: 'Name here',
      orderDate: '12 Aug 2022',
      time: 'Times Up',
      orderID: '#93481073',
      results: '+1 Point',
      status: 'Late order'
    },
    {
      clientName: 'Name here',
      orderDate: '12 Aug 2022',
      time: '12:25 am',
      orderID: '#93481073',
      results: '+1 Point',
      status: 'Rejected'
    },
    {
      clientName: 'Name here',
      orderDate: '12 Aug 2022',
      time: '1:30 am',
      orderID: '#93481073',
      results: '+1 Point',
      status: 'New'
    },
    {
      clientName: 'Name here',
      orderDate: '12 Aug 2022',
      time: '00:00 am',
      orderID: '#93481073',
      results: '0 Point',
      status: 'Cancelled'
    }
  ];

  return (
    <div className="view-details p-3">
   <div className="headerr">
  <div className="stock-filters">
    <button className="stock-filter actives">24 Hour</button>
    <button className="stock-filter">7 Days</button>
    <button className="stock-filter">30 Days</button>
    <button className="stock-filter">12 Months</button>
  </div>
  <div className="search-wrapperr">
    <input
      type="text"
      placeholder="Search by order id"
      className="stock-search"
    />
    <i className="fa-solid fa-magnifying-glass search-icon"></i>
  </div>

  <div className="stock-header">
    <input type="date" placeholder="select dates" />
    <div className="stock-actions">
      <button className="stock-btn blue">Filters</button>
      <button className="stock-btn">Export</button>
    </div>
  </div>
</div>

  

      <div className="service-header">
        <div className="service-info">
            <input type="checkbox" />
          <div className="service-icon">LM</div>
          <div className="service-details">
            <div className="service-name">Ads Services</div>
            <div className="service-type">Ads Product</div>
          </div>
          <span className="status-label">stable</span>
        </div>
        <div className="service-stats">
          <div className="stat">
           
             <span  style={{
                  backgroundColor:"#eaf4ff",
                  padding:"2px",
                  paddingLeft:"5px",
                  paddingRight:"5px",
                  borderRadius:"7px",
                   fontWeight:"bold",
                }} className="price">
                  $14.88
                  </span>
          </div>
          <div className="stat">
           <div className="sales-info">
                             <span  style={{
                           backgroundColor:"#dedede",
                           fontWeight:"bold",
                           padding:"2px",
                           paddingLeft:"5px",
                           paddingRight:"5px",
                           borderRadius:"7px"
                         }}>1,368</span>
                             <span className="sales-change fw-bold">
                               <FaArrowUp />
                             1,368</span>
                           </div>
          </div>
         
  <button  className="details">
                      View Details
                    </button>   
          
     </div>
      </div>

      <div className="orders-table">
        <table>
          <thead>
            <tr>
              <th>Client Name</th>
              <th>Order Date</th>
              <th>Time</th>
              <th>Order ID</th>
              <th>Results</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order, index) => (
              <tr key={index}>
                <td>{order.clientName}</td>
                <td>{order.orderDate}</td>
                <td>{order.time}</td>
                <td>
                  <div className="order-id">
                    {order.orderID}
                    <button className="copy-btn" title="Copy ID">
                      <FiCopy />
                    </button>
                  </div>
                </td>
                <td className={`results ${order.results.includes('-') ? 'negative' : 'positive'}`}>
                  {order.results}
                </td>
                <td>
                  <span className={`status-badge ${order.status.toLowerCase().replace(' ', '-')}`}>
                    {order.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="pagination">
        <span>Showing 17 of 100</span>
        <div className="page-numbers">
          <button className="active">1</button>
          <button>2</button>
          <button>3</button>
          <button>4</button>
          <button>5</button>
          <button>...</button>
        </div>
      </div>
    </div>
  );
};

export default ViewDetails;
